var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconStarFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_-_star_-_filled",
    "data-name": "Icon - star - filled",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15.314,
    viewBox: "0 0 16 15.314",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "star",
    d: "M27.641.52,25.688,4.48l-4.369.637A.957.957,0,0,0,20.79,6.75l3.161,3.08L23.2,14.181a.956.956,0,0,0,1.388,1.008L28.5,13.135l3.909,2.055A.957.957,0,0,0,33.8,14.181L33.048,9.83l3.161-3.08a.957.957,0,0,0-.529-1.633L31.311,4.48,29.358.52A.958.958,0,0,0,27.641.52Z",
    transform: "translate(-20.5 0.013)",
    fill: "#efb243"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconStarFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon - star - filled.e9c727e340db0135abb205fa8be41aa1.svg";